import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import type { RouteConfig } from './types';
import { authRoutes } from './auth.routes';
import { userRoutes } from './user.routes';
import { adminRoutes } from './admin/admin.routes';
import { ComponentSuspense } from '@/components/ui/suspense-wrapper';

const DashboardLayout = lazy(() => import('@/components/layout/dashboard-layout'));
const NotFoundPage = lazy(() => import('@/pages/not-found'));
const OnboardingPage = lazy(() => import('@/pages/app/user/onboarding'));
const OnboardingCheckoutPage = lazy(() => import('@/pages/onboarding/checkout'));
const OnboardingIndexPage = lazy(() => import('@/pages/onboarding'));
const CreateCompanyPage = lazy(() => import('@/pages/create-company'));

const authenticatedLayoutRoute: RouteConfig = {
  path: "/",
  element: (
    <ComponentSuspense >
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </ComponentSuspense>
  ),
  meta: {
    requiresAuth: true,
    requiresSubscription: true,
  },
  children: [
    ...userRoutes.map(route => ({
      ...route,
      meta: {
        ...route.meta,
        roles: route.meta?.requiresAuth === false ? undefined : ["User"],
        requiresAuth: route.meta?.requiresAuth !== false,
        requiresSubscription: route.meta?.requiresSubscription !== false
      }
    })),
    ...adminRoutes.map(route => ({
      ...route,
      meta: {
        ...route.meta,
        roles: ["Admin"],
        requiresAuth: true,
        requiresSubscription: true
      }
    })),
  ]
};

const notFoundRoute: RouteConfig = {
  path: "*",
  element: (
    <ComponentSuspense >
      <NotFoundPage />
    </ComponentSuspense>
  ),
  meta: {
    requiresAuth: false,
    title: "UzaForm | Not Found",
    description: "Page not found "
  }
};


const onboardingRoutes: RouteConfig[] = [
  {
    path: "/onboarding",
    element: (
      <ComponentSuspense>
        <OnboardingIndexPage />
      </ComponentSuspense>
    ),
    meta: {
      requiresAuth: true,
      title: "Onboarding | Uzabox Central",
      description: "Complete your onboarding",
      requiresSubscription: false,
    },
  },
  {
    path: "/onboarding/checkout",
    element: (
      <ComponentSuspense>
        <OnboardingCheckoutPage />
      </ComponentSuspense>
    ),
    meta: {
      requiresAuth: true,
      title: "Checkout | Onboarding",
      description: "Complete your payment",
      requiresSubscription: false,
    },
  },
  {
    path: "/create-company",
    element: (
      <ComponentSuspense>
        <CreateCompanyPage />
      </ComponentSuspense>
    ),
    meta: {
      requiresAuth: true,
      title: "Create Company | Uzabox Central",
      description: "Create a new company",
      requiresSubscription: false,
    },
  },
];

export const allRoutes = [
  ...authRoutes.map(route => ({
    ...route,
    meta: {
      ...route.meta,
      requiresAuth: false
    }
  })),
  ...onboardingRoutes,
  authenticatedLayoutRoute,
  notFoundRoute,
];